export default {
	"Beans.MyGrowingBeans": "我的成長豆",
	"Beans.MarketingMallComponentClick": "行銷商城_元件點擊",
	"Beans.MarketingMarketplace": "行銷商城",
	"Beans.ViewDetails": "查看詳情",
	"Beans.MyRedemptionHistory": "我的兌換記錄",
	"Beans.RedemptionHistory": "兌換記錄"
}